import type { GridColumnInfo, GridOptions } from '../types'
import type { GridConfigContext } from '../types/grid-config-context'

/** 列 uploadPath 为空时不传 path，由后端写入桶根；目录前缀去掉前导 / 并补末尾 / */
export function normalizeColumnUploadPath(
  uploadPath?: string
): string | undefined {
  let path = uploadPath?.trim()
  if (!path) return undefined
  path = path.replace(/^\/+/, '')
  if (!path) return undefined
  return path.endsWith('/') ? path : `${path}/`
}

/** 解析列上传附加表单：uploadData 优先，其次 uploadPath → { path } */
export function resolveColumnUploadData(
  column: GridColumnInfo,
  row: Record<string, unknown>
): Record<string, unknown> | undefined {
  if (column.uploadData) {
    const data =
      typeof column.uploadData === 'function'
        ? column.uploadData(row)
        : column.uploadData
    if (!data || typeof data !== 'object') return undefined
    return { ...(data as Record<string, unknown>) }
  }

  const path = normalizeColumnUploadPath(column.uploadPath)
  if (!path) return undefined
  return { path }
}

/** 列 → GridOption → ConfigProvider.grid */
export function resolveColumnUploadAction(
  column: GridColumnInfo,
  options?: Pick<GridOptions, 'uploadAction'>,
  globalConfig?: GridConfigContext | null
): string {
  return (
    column.uploadAction?.trim() ||
    options?.uploadAction?.trim() ||
    globalConfig?.uploadAction?.trim() ||
    ''
  )
}

/** path 以 / 结尾时为目录前缀，由后端生成 UUID_文件名；否则原样提交 */
export function applyUploadPathWithFilename(
  data: Record<string, unknown> | undefined,
  _filename?: string
): Record<string, unknown> | undefined {
  if (!data) return undefined
  return { ...data }
}
